import { defineMessages } from '@/hooks/useTranslation';

export default defineMessages({
  header: {
    title: {
      de: 'CTO Service',
      en: 'CTO Service'
    },
    description: {
      de: 'IT-Führungskompetenz nach Bedarf - CTO Service für Ihr Unternehmen.',
      en: 'IT leadership expertise on demand - CTO Service for your company.'
    }
  }
}); 